module.exports = __webpack_public_path__ + "img/cmp-toc-expand.ebaa15d9.svg";